import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';

const vehicleData = {
  // Sedan Executive
  "volvo-s90": {
    name: "Volvo S90",
    displayName: "VOLVO S90: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "/vol1.webp",
    mainContentImage: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAIEA7QMBIgACEQEDEQH/xAAbAAABBQEBAAAAAAAAAAAAAAAEAAIDBQYBB//EAFEQAAEDAQMECwsJBQcEAwAAAAIAAQMEBRESEyEiMQYyQUJRUmFykrHBFGJxgYKRoaLR4fAVIzM0Q1Njc5MHJCWywhY1VIOU0uJFs/HyRGR0/8QAGAEBAQEBAQAAAAAAAAAAAAAAAAECAwT/xAAcEQEBAQEBAQEBAQAAAAAAAAAAARECMSEDgRL/2gAMAwEAAhEDEQA/APTpSR8b6A81upVkrqxh+hHmt1KiRk5NTmRVXbz6EHOfqZUzure39pBzn6mVM7rcZNJ1AbqQ3UJug0exl/3OX81+plbqm2LfUJfzX6mVysVXF1cXUUPaP1Cp/KLqdY5nWwtH6hU/lF1Osey1ylPTCTmTXWmUZOi7Bf8AjEHlfyug5EVYb4LVpsXGL+V1L4rZumumvURfej0r1GVTFxvVf2LDTpOoylUclVF33RftQE9cIb0vR7VYg4p0HaEuOjn/AC3UBVw8UkDaloEFBOWSH6N997lUoF3XVXNXlv4h/U9yd8pYNvF0Sv7FuIPTSQDWtF91J6PauvakHFk6Le1KCJFA7qIrSpe+6Kh+UabjF0S9ihXoEzqzg+hi5rdSzs8xBxuk6t6ccdNEWIvo23z8C5ND2Xb0E4d8XSTRHvi6SAfZDJEAQY5R2z75uBlSvIPGHpMi9kT46CmI9t7lm5pFvnxFqRd8oJFSTkhpD01pHoWxqbJUco4SL51+pla91/het7lldhJfw2fvan+lloS/qbrZc760KeoLij6XTe6S73o+9QM/x4En+PMoplpzy/JtZpfYHvW4H4ViWqJeN6rLYWl/dtZ+QeLzOsRet8pRD1k4b4ej71EVpT/h9F/aoTdCyHgMvVWmaMO0pfw+i/tRNh2gUtsUw4R0jdsXidUs2mi9jD/x6j/ML+V1L4keiu5KMy2vO7HTnxKMnxmPj6nWG0UxKtqHx4ed2OrKVlXy4Qw/G46QqBn0C2yDtXQsqp/LRRDoIW1m/htT+W63GVDemyLhEoyk0NNbZRvJp+T2smmW+TBLT+ORI3UUwj00O0hN1LuJMLaB4EWPUJnV9S/VoPyx6mWemWipPq0H5Y9TLlWocTJXLpLjKKotkL/uFH8bjLMk2NaLZGxdx0Pj6mWeJlvnxmg6h9Ai+NaDctPD6yMqtoWNCyNp/wAq1ErYbB/7tqdH7f8ApZaKT2el1ndhD/w2p/P/AKWV9If8zdaxfWp4dG6e/wAehCTVEVOGVlLD28jNwqmq7Urqs8lRQFGPGLW/m1edlJNNxcWtKIWbU4yESKImHETNfmfVwrCnKOPbCpbb7psymy9ROOVkvwiO2zNnd3Zr3u8d+ZDU1NasVN87WVeVLOWKc3uzbXXuNwa3vfdXXmYxbp+IfvYx5xXdaY9Lj0svD3ulyeBdAq4DHKyjIO+yose5wuzu3idlXUrxWnCRZLuSXE7CYldG9zuzXu7u46t3E2fO4sqgySlI/tY+k/sRFhQDQ2rTVMso5KMncsJX62dut1mKvu6hrMNQUg5M9OItHU+ds2p1b01TBKGKLD2qVY3B7J7HCpGlKsEZ5DEAEs17vmZmv1vfmubPnVrjH48HKvP3whkp8IlrwHutdra987e9WlnySygRBPhISuwlf4t1YxrWnkIcH8yrqhtrzn6nQUtZkvrWQkEdsRFq8LvqQh7IrHx4crUkXFDSG/wl2On+amrJ0Fav921ODiOnRWxRy4dIhHjHdd52d7vGuWv/AHVU99G7q/TWZJ1DI2MObtVLf6xJjPttFbZD4ttg22HR4L1yY8ACSbiLH5L4vQmFiObi4b9LxIpplxNL4zdqHv0A8CllcjxYB0vjzeFQx7QeayD1aoWhpPq0H5Y9TKhnZXNOf7tF+W3UuNbggkr1C0iWUUVR7JC/dqHx9TLPG6vtkP1ajHi39TKgkw79b58ZC1YCYYt97EPM2A0a9PLUBkooiLR3u54X3EdT7Hpz0qjw6BC3nd/ZuLSUbsPPBRy/m/0ss7Fs9rrQ2VQWPRWdBkJKnIiZSO5m2e4mZmuZrmvz35lqaWzpaSmKCnGPJTXuWMnO+9mZ9y6665ruVZothdXZlvDblgyU8Mscb5OlyWi5O1z4Sd3YHdt27Ne+pnzTDWwppLKO0u4ZbRhntDOxDie5nbWI7jO3Bfi138DWz0kFOBbUR1kXg3XXlEtMVnhBPathxwYpLgI42m+cd3dmZxEs7vqe7ddbGMbRq4RIq6vjykd5AROLtfuOzsz369zc5USq6CP5e2SFOY4oKe48HAzPdGz8F7sReEHWnkszHTaA8uiqf5Mn/wAdW/re5VNuRFRZMQ+VKmWYrgwYjG/gd2bN4XzK/wBB9sWfUww/NQSEUhYNEXfXr1cirtjlnkFmxY4smRA2LKjc+dmvvZ8+u/cu5VOFkjKAlKVbGRCzmJT52v3NXh83KmlZEG/nq/1UA+yWkGoPFEOEREYwHvRZhbx3Myxk8M9IeVi0Vs5bLg40/lSX9iGKyYO+8oRfrZaRUUNrSy0w0xRD9Jfiyl2e67zK+s55Yj+algEiG7CeK7kz3Neq+sg7khIgyeSHbkYiLMzM7u9/JdwKlktqjiP6zTYSvYhGSS5s1+dmC7h1cKxbzHWfl3ZuNHV7H6yoMp6q04NInfCQvha/ga9AHYlLEeKW37LHnyi3W6zk9bYpniMaAi4xQmT+kGUVPNT1FSUVLBY4juFKLhfn13XO9zZuXkzKTvU6/HqTa0xRWeH0WyOxR4R7rZm8N173KSOqGKGWCLZDYBRSDcQFXjd4r2zP4PMs29LU6WCCwtHvnz+DN1pncFYf2Vi6X4j5vDmWtrGNSZRBpBU0kg/gTgfU6ifaLG1dmEGIqgrLHCLvhGR7/Fm3dSdZVRTURjLFXQCI7eIo5BZ79zMzs7tuOpe89dOeL140+L54h73z50PJoB5V+kWvgv4VMxxHNii0hwvpeZ+Dgfk7Exy70VqXfrFmXKGyn8yYO0HmspZX4iHjcsA81lUevTkPGVnA/wAzFzG6lXzWbEe9Ho+9M7mnD6KchEcwjlDubxXrlW1oDpuJVThXBtKn1n7WULtaIbSfq7WUElvfYeV2KjaIpakYsQjiJmEi5Xuvd0TXwWnUYcc5aO10QbX4lQ2zRWjT2bUynOWEY30dFs91zZ2a/XctRDa3ZoMVTLR2LQdc00McjtlTmYHmdtbjm1efxaldTbPrMp7EgnohxVJXsVMejgdsz4n5H3L734bs6wd0UUMVLSjHiwtTy5eEXwE8kTsWdtWByfge4nVNaBQHU5WlxdzSacWLXh3L+Xc8SUjaF+0+uAywU1JwfRnueVyqAv2nWx9xSfpF7Vj8sW8UZTSqK1sv7SLcPaSxx8yIe1nQj/tBt/GRd0l+hH/tWbeWXjEujPKlGmj/aPbgbeWMudAHYzI6zv2k2idSPdUVNJFvhGNxfxOz5n8TrGtPKnyCORy5jhIc5EPA2dQel2ns8sWkAcBSTlJpkIDnG9tT35r21a9xcpLfo7bDFQT4sO3EsxNfws/Xq1rzalpZipJ66qyeVEGmPFHlDwu7MzALuzXNia93duBr7numrIZ7EryqaUo8vTlcRRbQxfXe247Xte25ez8DrSPW4W0NNUuyS3qOxKYiMsVSW0i7Xu1MsJWbL7TqDLBVFGJb0Lmua7ce69UU1UR9Zcvh4VLVkmtVshOutimglCeCfDmGCIgEWF2Z3fXne+5t3arOyWXaIbahkLmDi6txNhKxzh/eIqsp99ikFgv5Lmd/Om/uJ6MVLH5U5v/SyxOXp7/bnqZhxyFUYh7lpoNJ8WGNgdnve9uRm1Xcia9KX3tN+r7kPKXEycfNIn61G8hfej0X9i28wkqL8ek/Uf2JncX49J+o/sUBHxpfVXL/xfVdBN3KP39N0n9ilpI5cckFPBTVJTROGkOJwvudyF3uZia7XuXuoYwgx4ZazJ/5RO/mzI2mhscD+frqmcc2IRombzO8jKVZcaezISp6YRLCWtywkztnYb2vZ2Z+BSGW2TIKmzpYRGyBnGCMcGTnFr9d9+Z3v3eBMdywEunPjPd3r45I6HZxGMPAnGWmoR+jDwLTL2M6+UN6hztUg+y9X3pSAhJQJcmkpW4IbaLrUZW/Bvx9b3IKWMkHNEXFTDVsWyGj+CVfbtrUdXY9TFERYsLPubjs/Yqoo9D6L1ULKA7+L1VcAncw1FflbSqRqYoc0wwQXMwszuImd4u7szamZybVu3PQ26VT3ZTDXlTFLguxU12Bw1hdduYcN1+e65XIykB4osmORIcY6nd3lApCfkcIx8yyFo1EXdOGlxDFCLBFpX5m5U0aCGjsww+dtiOPR2pUkz8O6zOymChsPH87b44d9hpJ7/wDt9qr7Ho6yupsudSMY4nYRMie+7W+vhvbxK0ayS38Uchf/AK8HoeJ0BkVJsGD6W2q2TjYYJWbzZJ1G9PsGP/qtbHpPvZXe5ndmfNC7Z2ue7Xnz3PmQ3yT/APRk8ivjfrhZQy2UG9o63ySgPtFTDUtTRbGcH7lsmkGXejPSTu3jdo83mdU9YMH1YKyOrEsLPJFHIDXO7M43GIvf4rs+tESWYX+Gq/KgDraV+pV9QE9OYlLTSRxCbaRRuzZnZ9b+1BY2rUCACNRSyUkoxFCRSxkwzxk7ExM77rHn4HZ83AlUzQZGpoZYJBriI6uqIxcXFzdmYLn3GZxe/kzcp4ZSUw7qrpCEgeSKCAhFoYhZryfNnJ3uAW1Xve75nZK3660SpqkjnEqGbNhjHDk5gLC48Ltezu19+bVqWhl7PqBp/nTpYJ9G7DPicW5bmcb0eNuT/ZWdZY82iZ/S7uqYDwBtV0ZSPaaXejnWVWZ92V32VFH32Thi1+G59xCFSEB6c9N+sL9SieOf/DT/AKb+xEUM9dSGRRQVA8JBE2LpODu3iQcani/x1B5UvuRVnxUITZWqrKYhHaiBOV78uZGNbtv7yW2v17uqNkJUW/skD6W0bUjHvp5G9N6I0liWtZlPDPFUSz6VS0wHBG73tc7Oz6s21zcjq5bZNZhnLLkK3EUgGIxUxOzOzOz3XXPnvZ+W5mzLzh7ftov+sWl/rZPamPbVq761a/8A1cntW71tTG9tS16Grsqeh+TrUny2B2KSiK5nYmfPus12Zrm3eRY2WyJcfzUVbh3onRSX+e7OhqettWrqYoBtGrxSSMAkdTJcN73Xu9+ptbrXUuxWWX67shynexSO7+dy7FFBbFbI7r7pGUpBw3OI4XZ91s9+r3Oroti8H3snRdXVl0lHZlMNNFOUnGM5Gcj8Loxy4mJIVkj2LQcaToqN9i1Lxp/0/etjg71J4+d0mV1MXchoaQ06WMuMXo9iEkbvi9HsWVdkNDSEmyc7q9iGk5xej2KjhbTyW3yFkjHvuknE6gMkRX11j0dWeKUcRc4m6nVcWxezvupP1CftV2UnfKNpUKqf7PQBtJZx/wAwvRnTH2P8Wef9R1dZXvE/KjxUxGeOwJd7UydJ0NLYdYH2pdJ1qmlFOximEYqWy64N9J0nQU1HVbUykw8UidegFh3+FMcIkxdZKnnE6OWCUhgqSiaMZS1YWNiufxs3v3ILeropTlGnIsM0pTHpZsRXX3eZvMy1lRZ9HUfSxCXOQRbHbMP7DokXtTDWHd0fHa9SHF6lpC2M2dvMX6jpj7F6P8TpKYapGtuX7oU9rc48XrK2fYtS8aRN/stF96XWrDYrmtoeKSR2tBKBRS5TCQ3EPI6sP7LRfekuf2Xi+9JMGVNhA9AsQ71cWqfYvF9+XoTH2MD96SmGqux3Gnmy5kOIdoOu6/dV0Npc1DvsZH71JtjpBtC9Z1cNFtX77Jes6e1fzh5qHayJQT+4pQ3qYaJjtWUNpPOPle9SfLM5f/Jkbyn9qFaAuKntC++FMNexm4oeQR34/HiTDiLeTl19qHk7sDaFGXOv9iyps1LAfe+btQklBFvC9Vuy5SHU1Ibelxc0v/KHO0YseGWKSPnKwDy2bxJR8rN2Og5bNn77ycL9bsrErQpj+1629LpNPFLtJxLvRJnVRRy0M4b0ui79TOgzEg25CJd8TD13LUOXe4Uwj+M3aqVmsnLtsJFzc7ehMv01ozhpjPEcEfPybX+1RlBB3w+UXovdEUGNJjV1JQxaWj0sPZchCsscehKPpb03ugBc11piU72bLvNLmSM/WzJj0UvFkHyWfqd3QMeTH/xXMoKRU8oB/wAXHrZlHhl4qsE2JdynfIVz4/am4koMyq5lkKzpOSQFNOP/AKpzzc5CPiSvQFZVLFzUMxpCSApi71J3HjdLP40Jj+MS7lEQUzfGpc+PhkO0n/FdyqCVxHiprAm4+auY+9LpIPUiQ5pJLDaA1FJtEklRj7Y+sqtqUkkRc2L9WVhCkkrB0duKbNt0klQJN9MPNbsUpfQ/HCkkge+98XWmU++5ySSiFv8AyVBVb1dSVgBZRTpJJQI23Jdbb+ZJJODO3Jdbb+ZJJODP9z9a5v/jhSSQP3nm63SPepJIhsO38/Uny9rpJIP/Z",
    paragraph1: "The Volvo S90 is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Volvo S90 is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/vol4.webp", "/vol5.webp", "/vol2.webp", "/vol1.webp"]
  },
  "cadillac-xt6": {
    name: "Cadillac XT6",
    displayName: "CADILLAC XT6: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "xt62.webp",
    paragraph1: "The Cadillac XT6 is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Cadillac XT6 is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/xt63.webp", "/xt64.webp", "/xt62.webp", "/xt61.webp"]
  },
  // Sedan Luxury
  "mercedes-s-class": {
    name: "Mercedes S Class",
    displayName: "MERCEDES S CLASS: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "sclass1.webp",
    paragraph1: "The Mercedes S Class is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Mercedes S Class is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/sclass4.webp", "/sclass3.webp", "/sclass2.webp", "/sclass1.webp"]
  },
  "bmw-7-series": {
    name: "BMW 7 Series",
    displayName: "BMW 7 SERIES: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "bmw72.webp",
    paragraph1: "The BMW 7 Series is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the BMW 7 Series is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/bmw74.webp", "/bmw73.webp", "/bmw72.webp", "/bmw71.webp"]
  },
  // Sedan Premium
  "mercedes-maybach": {
    name: "Mercedes Maybach",
    displayName: "MERCEDES MAYBACH: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "may1.webp",
    paragraph1: "The Mercedes Maybach is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Mercedes Maybach is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/may4.webp", "/may3.webp", "/may2.webp", "/may1.webp"]
  },
  // SUV Luxury
  "chevrolet-suburban": {
    name: "Chevrolet Suburban",
    displayName: "CHEVROLET SUBURBAN: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "subu2.jpg",
    paragraph1: "The Chevrolet Suburban is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Chevrolet Suburban is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/subu4.webp", "/subu3.jpg", "/subu1.webp", "/subu2.jpg"]
  },
  "gmc-denali": {
    name: "GMC Denali",
    displayName: "GMC DENALI: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "gmc2.webp",
    paragraph1: "The GMC Denali is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the GMC Denali is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/gmc4.webp", "/gmc3.webp", "/gmc2.webp", "/gmc1.jpg"]
  },
  "lincoln-navigator": {
    name: "Lincoln Navigator",
    displayName: "LINCOLN NAVIGATOR: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "lin2.webp",
    paragraph1: "The Lincoln Navigator is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Lincoln Navigator is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/lin4.webp", "/lin3.webp", "/lin2.webp", "/lin1.webp"]
  },
  // SUV Premium
  "cadillac-escalade": {
    name: "Cadillac Escalade",
    displayName: "CADILLAC ESCALADE: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "esc2.JPG",
    paragraph1: "The Cadillac Escalade is more than just a car, it's a statement of sophistication. With its sleek exterior and plush leather interior, it sets the tone for any event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Cadillac Escalade is perfect for both solo travelers and small groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/esc4.JPG", "/esc3.JPG", "/esc2.JPG", "/esc1.JPG"]
  },
  // Bus
  "mercedes-sprinter-8-seater": {
    name: "Mercedes Sprinter 8 Seater",
    displayName: "MERCEDES SPRINTER 8 SEATER: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "82.jpg",
    paragraph1: "The Mercedes Sprinter 8 Seater is more than just a bus, it's a statement of sophistication. With its spacious interior and comfortable seating, it sets the tone for any group event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Mercedes Sprinter 8 Seater is perfect for small to medium groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/84.webp", "/83.webp", "/82.jpg", "/81.jpg"]
  },
  "mercedes-sprinter-11-seater": {
    name: "Mercedes Sprinter 11 Seater",
    displayName: "MERCEDES SPRINTER 11 SEATER: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "111.webp",
    paragraph1: "The Mercedes Sprinter 11 Seater is more than just a bus, it's a statement of sophistication. With its spacious interior and comfortable seating, it sets the tone for any group event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Mercedes Sprinter 11 Seater is perfect for medium groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/114.webp", "/113.webp", "/112.webp", "/111.webp"]
  },
  "mercedes-sprinter-15-seater": {
    name: "Mercedes Sprinter 15 Seater",
    displayName: "MERCEDES SPRINTER 15 SEATER: THE EPITOME OF LUXURY GROUND TRAVEL",
    image: "152.png",
    paragraph1: "The Mercedes Sprinter 15 Seater is more than just a bus, it's a statement of sophistication. With its spacious interior and comfortable seating, it sets the tone for any group event. Whether you're heading to a corporate meeting or a special celebration, this vehicle ensures you arrive in elegance and style.",
    paragraph2: "Known for its advanced features, smooth ride, and ample space, the Mercedes Sprinter 15 Seater is perfect for larger groups. It offers privacy, premium comfort, and a luxurious atmosphere that elevates every journey, no matter the distance.",
    galleryImages: ["/154.webp", "/153.webp", "/151.jpg", "/152.png"]
  }
};

function VehicleDetail() {
  const { slug } = useParams();
  const vehicle = vehicleData[slug];

  if (!vehicle) {
    return <div>Vehicle not found</div>;
  }

  return (
    <>
      <section 
        className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
        style={{
          backgroundImage: `url('${vehicle.image.startsWith('/') ? vehicle.image : '/' + vehicle.image}')`,
        }}
      >
        <Header/>

        {/* Hero Content */}
        <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
          <div className="max-w-5xl text-center text-white">
            <h1 className="font-bold leading-snug text-white">
              {vehicle.name} Chauffeur
            </h1>
            <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
              <a href="/" className="hover:text-logo-green">Home</a>
              <span>-</span>
              <a href="/fleet" className="hover:text-logo-green">Our Fleet</a>
              <span>-</span>
              <span className="text-logo-green">{vehicle.name}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section - Left Text, Right Image */}
      <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1100px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Left Side - Text Content */}
            <div className="order-1 lg:order-1">
              {/* Horizontal Line */}
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              
              {/* Main Heading */}
              <h2 className="font-bold text-gray-900 mb-6 sm:mb-8 leading-tight">
                {vehicle.displayName}
              </h2>
              
              {/* First Paragraph */}
              <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
                {vehicle.paragraph1}
              </p>
              
              {/* Second Paragraph */}
              <p className="text-base sm:text-lg text-gray-900 mb-6 sm:mb-8 leading-relaxed">
                {vehicle.paragraph2}
              </p>
              
              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green hover:text-black transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>

            {/* Right Side - Large Image */}
            <div className="order-2 lg:order-2">
              <img 
                src={vehicle.image.startsWith('/') ? vehicle.image : '/' + vehicle.image} 
                alt={vehicle.name} 
                className="w-full h-[400px] sm:h-[400px] lg:h-[400px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Map-like Image Section */}
      <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Left Side - Text Content */}
            <div className="order-2 lg:order-1">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Experience Luxury Travel
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                Our premium {vehicle.name} service ensures you travel in comfort and style. Whether you're heading to the airport, attending a special event, or need reliable transportation, we've got you covered.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                With professional chauffeurs and meticulously maintained vehicles, every journey with us is an experience in luxury and reliability.
              </p>
            </div>
            
            {/* Right Side - Map-like Image */}
            <div className="order-1 lg:order-2">
              <img 
                src="/may1.webp" 
                alt="Luxury Vehicle" 
                className="w-full h-[400px] sm:h-[450px] lg:h-[500px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section - 4 Images */}
      <section className="bg-white py-8 sm:py-12 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {vehicle.galleryImages.map((img, index) => (
              <div key={index} className="overflow-hidden rounded-lg shadow-lg">
                <img 
                  src={img} 
                  alt={`${vehicle.name} ${index === 0 ? 'Interior Front' : index === 1 ? 'Interior Rear' : index === 2 ? 'Exterior Side' : 'Exterior Front'}`}
                  className="w-full h-[170px] sm:h-[250px] lg:h-[300px] object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Feature Cards Section */}
      <section className="bg-gray-800 py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Climate Control */}
            <div className="bg-gray-700 rounded-lg p-6 sm:p-8 text-center hover:bg-gray-600 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 text-white hover:text-logo-green transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                  <path d="M12 5.5c-3.59 0-6.5 2.91-6.5 6.5s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5zm0 11c-2.48 0-4.5-2.02-4.5-4.5S9.52 7.5 12 7.5s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5z"/>
                  <path d="M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                  <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                </svg>
              </div>
              <h3 className="text-white font-bold mb-3">Climate Control</h3>
              <p className="text-white leading-relaxed">
                Multi-zone climate control ensures perfect temperature for all passengers throughout the journey.
              </p>
            </div>

            {/* Free Wi-Fi */}
            <div className="bg-gray-700 rounded-lg p-6 sm:p-8 text-center hover:bg-gray-600 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 text-white hover:text-logo-green transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.07 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/>
                </svg>
              </div>
              <h3 className="text-white font-bold mb-3">Free Wi-Fi</h3>
              <p className="text-white leading-relaxed">
                Stay connected with complimentary high-speed Wi-Fi available throughout your ride.
              </p>
            </div>

            {/* Device Charging */}
            <div className="bg-gray-700 rounded-lg p-6 sm:p-8 text-center hover:bg-gray-600 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 text-white hover:text-logo-green transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M15.67 4H14V2c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 19v-5h2v5h-2zm0-7V7h2v5h-2z"/>
                </svg>
              </div>
              <h3 className="text-white font-bold mb-3">Device Charging</h3>
              <p className="text-white leading-relaxed">
                Multiple USB ports and wireless charging pads keep your devices powered up.
              </p>
            </div>

            {/* Premium Audio */}
            <div className="bg-gray-700 rounded-lg p-6 sm:p-8 text-center hover:bg-gray-600 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 text-white hover:text-logo-green transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
                </svg>
              </div>
              <h3 className="text-white font-bold mb-3">Premium Audio</h3>
              <p className="text-white leading-relaxed">
                Burmester surround sound system delivers crystal-clear audio for your entertainment.
              </p>
            </div>

            {/* Safety First */}
            <div className="bg-gray-700 rounded-lg p-6 sm:p-8 text-center hover:bg-gray-600 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 text-white hover:text-logo-green transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2.5 9.5l3 3 5.5-5.5-1.5-1.5-4 4-1.5-1.5-1.5 1.5z"/>
                </svg>
              </div>
              <h3 className="text-white font-bold mb-3">Safety First</h3>
              <p className="text-white leading-relaxed">
                Advanced safety features including collision prevention and emergency braking systems.
              </p>
            </div>

            {/* Refreshments */}
            <div className="bg-gray-700 rounded-lg p-6 sm:p-8 text-center hover:bg-gray-600 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-12 h-12 sm:w-16 sm:h-16 text-white hover:text-logo-green transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3H6zm6 10c-1.86 0-3.41-1.28-3.86-3h7.72c-.45 1.72-2 3-3.86 3zm4-5H8V5h8v3z"/>
                  <path d="M12 10c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"/>
                </svg>
              </div>
              <h3 className="text-white font-bold mb-3">Refreshments</h3>
              <p className="text-white leading-relaxed">
                Complimentary bottled water and mints to enhance your travel experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          
          {/* Service 1: Airport Transfer */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
            <div className="order-2 lg:order-1">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Airport Transfer: Arrive Refreshed and On Time
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                Skip the hassle of parking and traffic with our {vehicle.name} airport transfer. Whether arriving or departing, you'll enjoy a stress-free, private ride designed to make your travel day smoother.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                With prompt pickups, flight tracking, and experienced chauffeurs, our fleet guarantees a timely arrival at major airports or any private airstrip nearby. It's ideal for both business and leisure flyers seeking comfort and efficiency.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <img 
                src="/blog12.png" 
                alt="Airport Transfer" 
                className="w-full h-[300px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Service 2: Concerts and Festivals */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
            <div className="order-1 lg:order-1">
              <img 
                src="/service8.jpeg" 
                alt="Concerts and Festivals" 
                className="w-full h-[300px] object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-2 lg:order-2">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Concerts and Festivals: Show Up in Style
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                Why worry about parking and crowds when you can roll up in a {vehicle.name}? Our concert and festival transportation lets you enjoy your favorite events without the stress of driving or finding a spot.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                Whether you're heading to a sold-out show or a major festival, enjoy the ride just as much as the performance. The {vehicle.name} offers a luxurious space to pre-party, relax, and make an entrance worth remembering.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>

          {/* Service 3: Wedding Transportation */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
            <div className="order-2 lg:order-1">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Wedding Transportation: Luxury for Your Big Day
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                Make your wedding day even more magical with our {vehicle.name} wedding limo service. From bridal party pickups to honeymoon send-offs, every ride is elegant and unforgettable.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                Our vehicles are spotless, elegant, and perfect for photography moments too. With punctual service and a professional chauffeur, your wedding transportation will be as smooth and beautiful as the ceremony itself.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <img 
                src="/service3.jpeg" 
                alt="Wedding Transportation" 
                className="w-full h-[300px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Service 4: Corporate Limo Service */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
            <div className="order-1 lg:order-1">
              <img 
                src="/service5.jpeg" 
                alt="Corporate Limo Service" 
                className="w-full h-[300px] object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-2 lg:order-2">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Corporate Limo Service: Impress Your Clients
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                First impressions matter, and arriving in a {vehicle.name} speaks volumes. Our corporate limo service provides an upscale, professional image that reflects your commitment to excellence.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                Perfect for business meetings, client pickups, or executive travel, the {vehicle.name} ensures every ride is productive and relaxing. Wi-Fi, quiet interiors, and punctual service make it a mobile boardroom on wheels.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>

          {/* Service 5: City Tours */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
            <div className="order-2 lg:order-1">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Leisure Transportation: Ride Around the City in Style
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                Whether it's shopping, dining, or sightseeing, the {vehicle.name} is the perfect ride for a luxurious day out. Our leisure transportation makes every outing feel special.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                Enjoy the city's hotspots with none of the parking or driving hassles. Sit back and let our professional chauffeurs take you where you need to go, in total comfort and style.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <img 
                src="/service7.jpeg" 
                alt="Leisure Transportation" 
                className="w-full h-[300px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Service 6: Hourly Service */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
            <div className="order-1 lg:order-1">
              <img 
                src="/service2.jpeg" 
                alt="Hourly Service" 
                className="w-full h-[300px] object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-2 lg:order-2">
              <div className="w-16 h-1 bg-logo-green mb-6"></div>
              <h2 className="font-bold text-gray-900 mb-6 leading-tight">
                Hourly Service: Your Time, Your Ride
              </h2>
              <p className="text-gray-900 mb-4 leading-relaxed">
                Our hourly limo service with {vehicle.name} offers the flexibility to move through your day at your own pace. Whether it's multiple stops or simply having a ride on standby, you're in control.
              </p>
              <p className="text-gray-900 mb-6 leading-relaxed">
                Perfect for business days, sightseeing, or special occasions, this service includes a dedicated chauffeur ready whenever you are. Enjoy luxury and convenience every hour of your booking.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center rounded-lg"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-transparent border-2 border-black text-black px-6 sm:px-8 py-3 font-semibold hover:bg-logo-green hover:border-logo-green transition-colors text-center rounded-lg"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>

      <FAQ/>

      <Footer/>
    </>
  );
}

export default VehicleDetail;
